module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAmCAMAAABwIXKiAAAAAXNSR0IArs4c6QAAAD9QTFRFAAAA////////////////////////////////////////////////////////////////////////////////Q7v6agAAABR0Uk5TABAgMEBQYG9wf4CfoMDP0N/g7/A1DDfWAAAAhElEQVQ4y+3UyxKDIBBE0QaRGIMYtP//W7NQU+P4mmUq5d0Jx4JZKKAL7+xhKJGtxXW3u91/uJGycujiytWn39C35uJyc0nt+Eclnlw/s16TzEG+Vk2zFCfWMulAMqx+ByQ5yjMmoh3iZtR9h6RHPXCIsDn8mHs9z1ucoYBich51Z6jBB8deGNDvFBEjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/cl-down.png
// module id = HJYU
// module chunks = 0